export const constAccessType = {
    view: 1,
    add: 2,
    edit: 3,
    delete: 4
}
/*
export const constPromoGroup = [{
    id: 1,
    label: "Register"
}, {
    id: 2,
    label: "First Deposit"
}, {
    id: 12,
    label: "First Deposit (Levels)"
    },
// deposit promotion cannot recurring
//    {
//    id: 3,
//    label: "First Deposit (By Duration)"
//}, {
//    id: 13,
//    label: "First Deposit (By Duration, Levels)"
//    },
    {
    id: 4,
    label: "Each Deposit"
}, {
    id: 14,
    label: "Each Deposit (Levels)"
}, {
    id: 5,
    label: "Turnover Rebate"
}, {
    id: 15,
    label: "Turnover Rebate (Levels)"
}, {
    id: 6,
    label: "Cash Back"
}, {
    id: 16,
    label: "Cash Back (Levels)"
}, {
    id: 7,
    label: "One Time Bonus"
}];
*/

export const constSPromoGroup = [{
    id: -1,
    label: "Deposit Promotion",
    children: [{
        id: 2,
        label: "First Deposit"
    },
    {
        id: 22,
        label: "Extra Bonus First Deposit"
    },
    {
        id: 4,
        label: "Each Deposit"
    },
    {
        id: 24,
        label: "Extra Bonus Each Deposit"
    },
    {
        id: 8,
        label: "Each Deposit Free Spin"
    }
    ]
}];

export const constPromoGroup = [{
    id: -1,
    label: "Deposit Promotion",
    children: [{
        id: 2,
        label: "First Deposit"
    }, {
        id: 12,
        label: "First Deposit (Levels)"
    },
    {
        id: 22,
        label: "Extra Bonus First Deposit"
    }, {
        id: 32,
        label: "Extra Bonus First Deposit (Levels)"
    },
    {
        id: 4,
        label: "Each Deposit"
    }, {
        id: 14,
        label: "Each Deposit (Levels)"
    },
    {
        id: 24,
        label: "Extra Bonus Each Deposit"
    }, {
        id: 34,
        label: "Extra Bonus Each Deposit (Levels)"
    },
    {
        id: 8,
        label: "Each Deposit Free Spin"
    }, {
        id: 18,
        label: "Each Deposit Free Spin (Levels)"
    },
    ]
},
{
    id: -2,
    label: "Non-Deposit Promotion",
    children: [{
        id: 1,
        label: "Register"
    }, {
        id: 5,
        label: "Turnover Rebate"
    }, {
        id: 15,
        label: "Turnover Rebate (Levels)"
    }, {
        id: 6,
        label: "Cash Back"
    }, {
        id: 16,
        label: "Cash Back (Levels)"
    }, {
        id: 7,
        label: "One Time Bonus"
    }, {
        id: 17,
        label: "One Time Special Bonus"
    }, {
        id: 9,
        label: "Buy Bonus"
    }]
}
];

export const constPromoType = [{
    id: 1,
    label: "Fix Amount"
}, {
    id: 2,
    label: "Percentage"
}
    //, {
    //id: 3,
    //label: "Free Play"
    //}
];

export const constTurnoverType = [
    {
        id: -1,
        label: "Turnover",
        children: [
            {
                id: 1,
                label: "Turnover Multiply"
            },
            {
                id: 3,
                label: "Multiply (cap by max bonus amount)"
            },
            {
                id: 2,
                label: "Turnover Fix Amount"
            }
        ]
    },
    {
        id: -2,
        label: "Winover",
        children: [
            {
                id: 4,
                label: "Winover Multiply"
            },
            {
                id: 5,
                label: "Winover Fix Amount"
            }
        ]
    }
];

export const constTournamentType = [{
    id: 1,
    label: "Daily"
}, {
    id: 2,
    label: "Weekly"
}, {
    id: 3,
    label: "Monthly"
}];
export const constTournamentPointCalculationType = [{
    id: 0,
    label: "Default Point System"
}, {
    id: 1,
    label: "Total Turnover"
}, {
    id: 2,
    label: "Total Win"
}, {
    id: 3,
    label: "Total Loss"
}];
export const constMissionDurationType = [{
    id: 1,
    label: "Daily"
}, {
    id: 2,
    label: "Weekly"
}, {
    id: 3,
    label: "Monthly"
}];
export const constMissionType = [{
    id: 1,
    label: "Angpow"
}];
export const constPrizeType = [
    {
        id: 1,
        label: "Fix Amount"
    },
    {
        id: 2,
        label: "Random Amount"
    }
];
export const constContactDetail = [
    {
        id: 1,
        label: "Email"
    },
    {
        id: 2,
        label: "Phone"
    },
    {
        id: 3,
        label: "WeChat ID"
    },
    {
        id: 4,
        label: "LINE ID"
    },
    {
        id: 5,
        label: "WhatsApp"
    },
    {
        id: 6,
        label: "Telegram"
    },
    {
        id: 7,
        label: "Zalo"
    }
];
export const constPromoCondition = [{
    id: 1,
    label: "Min. Deposit"
}, {
    id: 2,
    label: "Last X month(s) Deposit"
}, {
    id: 3,
    label: "Total Turnover"
}, {
    id: 4,
    label: "Last X month(s) Turnover"
}];

export const constPromoExpiryDurationType = [{
    id: 0,
    label: "No Expiry"
}, {
    id: 1,
    label: "Day(s)"
}, {
    id: 2,
    label: "Week(s)"
}, {
    id: 3,
    label: "Month(s)"
}];

export const constPromoGroupType = [{
    id: 1,
    label: "Day(s)"
}, {
    id: 2,
    label: "Week(s)"
}, {
    id: 3,
    label: "Month(s)"
}];

export const constAutoRebateGroupType = [
    {
        id: 1,
        label: "Day(s)"
    },
    {
        id: 2,
        label: "Week(s)"
    },
    {
        id: 3,
        label: "Month(s)"
    }
];

export const constAutoRebateGroupTypeSA = [
    {
        id: 4,
        label: "Instant"
    },
    {
        id: 1,
        label: "Day(s)"
    },
    {
        id: 2,
        label: "Week(s)"
    },
    {
        id: 3,
        label: "Month(s)"
    }
];

export const constPromoApplyIntervalType = [{
    id: 0,
    label: "No Limit"
}, {
    id: 1,
    label: "Day(s)"
}, {
    id: 2,
    label: "Week(s)"
}, {
    id: 3,
    label: "Month(s)"
}];

export const constSEORobots = [{
    id: "noarchive",
    label: "No Archive"
}, {
    id: "nofollow",
    label: "No Follow"
}, {
    id: "noimageindex",
    label: "No Image Index"
}, {
    id: "noindex",
    label: "No Index"
}, {
    id: "nosnippet",
    label: "No Snippet"
}, {
    id: "notranslate",
    label: "No Translate"
}, {
    id: "none",
    label: "None"
}];

export const constStatus = [{
    id: "1",
    label: "Disable"
}, {
    id: "2",
    label: "Enable"
}];

export const constYesNo = [{
    id: "1",
    label: "Yes"
}, {
    id: "0",
    label: "No"
}];

export const constRejectReasonP = [{
    id: "1",
    label: "Unfinished previous promotion"
},
{
    id: "2",
    label: "Condition not meet"
},
{
    id: "3",
    label: "Same IP"
},
{
    id: "4",
    label: "No deposit"
},
{
    id: "5",
    label: "Missing deposit"
},
{
    id: "999",
    label: "Other"
}
];

export const constRejectReasonD = [{
    id: "1",
    label: "Didn't Receive Deposit"
},
{
    id: "2",
    label: "Bank Receipt/ Infomation Unclear"
},
{
    id: "3",
    label: "Incomplete personal details"
},
{
    id: "999",
    label: "Other"
}
];
// Balance Adjustment Reject Reason
export const constBARRejectReason = [{
    id: "1",
    label: "Didn't Receive Deposit"
},
{
    id: "2",
    label: "Bank Receipt/ Infomation Unclear"
},
{
    id: "3",
    label: "Incomplete personal details"
},
{
    id: "999",
    label: "Other"
}
];

export const constRejectReasonW = [{
    id: "1",
    label: "Hedging/Cheating"
},
{
    id: "2",
    label: "Unfinished turnover"
},
{
    id: "999",
    label: "Other"
}
];

export const constRejectReasonSW = [{
    id: "1",
    label: "Hedging/Cheating"
},
{
    id: "999",
    label: "Other"
}
];

export const constRejectReasonBL = [{
    id: "1",
    label: "Same IP/Multiple Account"
},
{
    id: "2",
    label: "Hedging/Cheating/Dishonesty"
},
{
    id: "3",
    label: "Suspicious/Abnormal Activities"
},
{
    id: "4",
    label: "Inactive Member"
},
{
    id: "999",
    label: "Other"
}
];
export const constSuspendReasonBL = [{
    id: "1",
    label: "Same IP/Multiple Account"
},
{
    id: "2",
    label: "Hedging/Cheating/Dishonesty"
},
{
    id: "3",
    label: "Suspicious/Abnormal Activities"
},
{
    id: "4",
    label: "Inactive Agent"
},
{
    id: "999",
    label: "Other"
}
];
export const constDisqualifyMemberAff = [{
    id: "1",
    label: "Same IP/Multiple Account"
},
{
    id: "2",
    label: "Hedging/Cheating/Dishonesty"
},
{
    id: "3",
    label: "Suspicious/Abnormal Activities"
},
{
    id: "4",
    label: "Inactive Member"
},
{
    id: "999",
    label: "Other"
}
];
export const constRejectReasonF = [{
    id: "1",
    label: "Same IP/Multiple Account"
},
{
    id: "2",
    label: "Hedging/Cheating/Dishonesty"
},
{
    id: "3",
    label: "Suspicious/Abnormal Activities"
},
{
    id: "4",
    label: "Inactive Member"
},
{
    id: "999",
    label: "Other"
}
];

export const constSMSVerification = [{
    id: "0",
    label: "Disable"
}, {
    id: "1",
    label: "By Profile"
}, {
    id: "2",
    label: "By Page"
}];
export const constEmailVerification = [{
    id: "0",
    label: "Disable"
}, {
    id: "1",
    label: "By Profile"
}, {
    id: "2",
    label: "By Page"
}];

export const constVerificationPage = [{
    id: "1",
    label: "Register"
}, {
    id: "2",
    label: "Login"
}, {
    id: "3",
    label: "Promotion"
}, {
    id: "4",
    label: "Deposit"
}, {
    id: "5",
    label: "Withdraw"
}];

export const constWeekday = [{
    id: "1",
    label: "Monday"
}, {
    id: "2",
    label: "Tuesday"
}, {
    id: "3",
    label: "Wednesday"
}, {
    id: "4",
    label: "Thursday"
}, {
    id: "5",
    label: "Friday"
}, {
    id: "6",
    label: "Saturday"
}, {
    id: "0",
    label: "Sunday"
}];

export const constPromotionStatus = [{ // key1 = CTNT
    id: "1",
    label: "Pending"//pending
},
{
    id: "2",
    label: "Approved" //AP
},
{
    id: "3",
    label: "Rejected" //RJ
},
{
    id: "4",
    label: "Completed" // CP
},
{
    id: "5",
    label: "Closed" //C
},
{
    id: "6",
    label: "Cancelled" //CCL
},
{
    id: "7",
    label: "Surrendered" //SRD
},
{
    id: "8",
    label: "Expired" //EP
},
{
    id: "9",
    label: "Carry Forward" // CF
}
];

export const constPromotionSystemApproved = [{
    id: "1",
    label: "YES"
},
{
    id: "0",
    label: "No"
}
];

export const constImgURClientId = "993793b1d8d3e2e";

export const constCountryCode = [{
    id: "0",
    label: "South East Asia",
    isDisabled: true,
    children: [{
        id: "bn",
        label: "Brunei"
    },
    {
        id: "bd",
        label: "Bangladesh"
    },
    {
        id: "kh",
        label: "Cambodia"
    },
    {
        id: "in",
        label: "India"
    },
    {
        id: "id",
        label: "Indonesia"
    },
    {
        id: "la",
        label: "Laos"
    },
    {
        id: "my",
        label: "Malaysia"
    },
    {
        id: "mm",
        label: "Myanmar"
    },
    {
        id: "np",
        label: "Nepal"
    },
    {
        id: "ph",
        label: "Philippines"
    },
    {
        id: "sg",
        label: "Singapore"
    },
    {
        id: "th",
        label: "Thailand"
    },
    {
        id: "vn",
        label: "Vietnam"
    }
    ]
},
{
    id: "1",
    label: "Asia",
    isDisabled: true,
    children: [{
        id: "cn",
        label: "China"
    },
    {
        id: "hk",
        label: "Hong Kong"
    },
    {
        id: "jp",
        label: "Japan"
    },
    {
        id: "ru",
        label: "Russia"
    },
    {
        id: "kr",
        label: "South Korea"
    },
    {
        id: "kz",
        label: "Kazakhstan"
    },
    {
        id: "pk",
        label: "Pakistan"
    },
    {
        id: "tw",
        label: "Taiwan"
    },
    {
        id: "uz",
        label: "Uzbekistan"
    }
    ]
},
{
    id: "2",
    label: "Europe",
    isDisabled: true,
    children: [
        {
            id: "pt",
            label: "Portugal"
        },
        {
            id: "es",
            label: "Spain"
        },
    ]
},
{
    id: "3",
    label: "MENA",
    isDisabled: true,
    children: [
        {
            id: "cm",
            label: "Cameroon French"
        },
        {
            id: "sa",
            label: "Saudi Arab"
        },
        {
            id: "tr",
            label: "Turkey"
        },
        {
            id: "ae",
            label: "United Arab Emirates"
        }
    ]
},
{
    id: "4",
    label: "Latin America",
    isDisabled: true,
    children: [
        {
            id: "br",
            label: "Brazil"
        }
    ]
    },
{
    id: "6",
    label: "Oceania",
    isDisabled: true,
    children: [
        {
            id: "au",
            label: "Australia"
        },
        {
            id: "pg",
            label: "Papua New Guinea"
        }
    ]
},
{
    id: "5",
    label: "Other",
    isDisabled: true,
    children: [
        {
            id: "cr",
            label: "Crypto"
        }
    ]
}
];

export const constWinLossType = [{
    id: "0",
    label: "All"
},
{
    id: "1",
    label: "Win"
},
{
    id: "2",
    label: "Loss"
},
{
    id: "3",
    label: "Draw"
}
];

export const consDeviceType = [
    {
        id: "",
        label: "All"
    },
    {
        id: "0",
        label: "Desktop"
    },
    {
        id: "1",
        label: "Mobile"
    },
    {
        id: "2",
        label: "Android APK"
    },
    {
        id: "3",
        label: "IOS IPA"
    }
];

export const consTypeofmember = [
    {
        id: "0",
        label: "Received Referral Bonus"
    },
    {
        id: "1",
        label: "Transfer Wallet Games"
    },
    {
        id: "2",
        label: "Member Never Withdraw"
    },
];

export const constAdjustmentType = [
    {
        id: "17",
        label: "Modify Initial Capital"
    },
    {
        id: "1",
        label: "Topup" + " / " + "Deduct"
    },
    {
        id: "2",
        label: "Downline Topup" + " / " + "Deduct"
    },
    {
        id: "3",
        label: "Downline Return"
    },
    {
        id: "4",
        label: "Member Deposit"
    },
    {
        id: "5",
        label: "Member Withdrawal"
    },
    {
        id: "6",
        label: "Promotion Pay"
    },
    {
        id: "7",
        label: "Promotion Overdue"
    },
    {
        id: "8",
        label: "Auto Rebate"
    },
    {
        id: "9",
        label: "Credit Adjustment"
    },
    {
        id: "10",
        label: "Debit Adjustment"
    },
    {
        id: "11",
        label: "Promotion Cancel"
    },
    {
        id: "12",
        label: "Promotion Surrender"
    },
    {
        id: "13",
        label: "Referral"
    },
    {
        id: "14",
        label: "Referral Bonus"
    },
    {
        id: "15",
        label: "Tournament Payout"
    },
    {
        id: "16",
        label: "Reset"
    },

];
export const constSubAdjustmentType = [
    {
        id: "1",
        label: "Modify Initial Capital"
    },
    {
        id: "2",
        label: "Topup"
    },
    {
        id: "3",
        label: "Downline Topup"
    },
    {
        id: "4",
        label: "Downline Return"
    },
    {
        id: "5",
        label: "Member Deposit"
    },
    {
        id: "6",
        label: "Member Withdrawal"
    },
    {
        id: "7",
        label: "Promotion Pay"
    },
    {
        id: "8",
        label: "Promotion Overdue"
    },
    {
        id: "9",
        label: "Reset"
    },

];


export const constMenuIcon = {
    AN: 'fa fa-bullhorn',
    M: 'fa fa-user',
    A: 'fa fa-user-tie',
    CMS: 'fa fa-list',
    MS: 'fa fa-bullseye',
    B: 'fa-solid fa-building-columns',
    D: 'fa-solid fa-circle-dollar-to-slot',
    W: 'fa fa-money-bill',
    P: 'fa-solid fa-percent',
    GS: 'fa-solid fa-gear',
    R: 'fa fa-chart-pie',
    AGS: 'fa fa-user-tie',
    SYS: 'fa-solid fa-gears',
    L: 'fa fa-clipboard-check',
    DASH: 'fa fa-chart-line',
    HELP: 'fa fa-info-circle',
    AFF: 'fa fa-handshake',
    CRM: 'fa fa-puzzle-piece',
    MAPP: 'fa-solid fa-mobile-screen-button',
    C: 'fa-brands fa-btc',
    WEBS: 'fas fa-globe',
    TOOLS: 'fa-solid fa-gears',
    PRS: 'fa fa-clipboard-check',
}

// member site also need to add same social media 
export const consSocialMediaNetwork = [{
    id: "0",
    label: "Facebook"
},
{
    id: "1",
    label: "Twitter"
},
{
    id: "2",
    label: "Instagram"
},
{
    id: "3",
    label: "Youtube"
},
{
    id: "4",
    label: "GooglePlus"
},
{
    id: "5",
    label: "Linkedin"
},
{
    id: "6",
    label: "Line"
},
{
    id: "7",
    label: "Snapchat"
},
{
    id: "8",
    label: "Reddit"
},
{
    id: "9",
    label: "Pinterest"
},
{
    id: "10",
    label: "Tumblr"
},
{
    id: "11",
    label: "TikTok"
},
{
    id: "12",
    label: "Medium"
}
];

export const consMetaRobot = [{
    id: "No Index",
    label: "No Index"
},
{
    id: "Index",
    label: "Index"
},
{
    id: "Follow",
    label: "Follow"
},
{
    id: "No Follow",
    label: "No Follow"
},
{
    id: "No Image Index",
    label: "No Image Index"
},
{
    id: "None",
    label: "None"
},
{
    id: "No Archive",
    label: "No Archive"
},
{
    id: "No Cache",
    label: "No Cache"
},
{
    id: "No Snippet",
    label: "No Snippet"
}
];

export const consBannerPosition = [{
    id: "1",
    label: "Position 1"
},
{
    id: "2",
    label: "Position 2"
},
{
    id: "3",
    label: "Position 3"
},
{
    id: "4",
    label: "Position 4"
},
{
    id: "5",
    label: "Position 5"
},
{
    id: "6",
    label: "Position 6"
},
{
    id: "7",
    label: "Position 7"
},
{
    id: "8",
    label: "Position 8"
},
{
    id: "9",
    label: "Position 9"
},
{
    id: "10",
    label: "Position 10"
},
{
    id: "11",
    label: "Position 11"
},
{
    id: "12",
    label: "Position 12"
},
{
    id: "13",
    label: "Position 13"
},
{
    id: "14",
    label: "Position 14"
},
{
    id: "15",
    label: "Position 15"
},
{
    id: "16",
    label: "Position 16"
},
{
    id: "17",
    label: "Position 17"
},
{
    id: "18",
    label: "Position 18"
},
{
    id: "19",
    label: "Position 19"
},
{
    id: "20",
    label: "Position 20"
},
{
    id: "21",
    label: "Position 21"
},
{
    id: "22",
    label: "Position 22"
},
{
    id: "23",
    label: "Position 23"
},
{
    id: "24",
    label: "Position 24"
},
{
    id: "25",
    label: "Position 25"
},
{
    id: "26",
    label: "Game Feature Position 1"
},
{
    id: "27",
    label: "Game Feature Position 2"
},
{
    id: "28",
    label: "Game Feature Position 3"
},
{
    id: "29",
    label: "Game Feature Position 4"
}
];

export const consGameFeaturePosition = [{
    id: "1",
    label: "Position 1"
},
{
    id: "2",
    label: "Position 2"
},
{
    id: "3",
    label: "Position 3"
},
{
    id: "4",
    label: "Position 4"
},
{
    id: "5",
    label: "Position 5"
},
{
    id: "26",
    label: "Game Feature Position 1"
},
{
    id: "27",
    label: "Game Feature Position 2"
},
{
    id: "28",
    label: "Game Feature Position 3"
},
{
    id: "29",
    label: "Game Feature Position 4"
}
];


export const consBannerType = [{
    id: "1",
    label: "Desktop"
},
{
    id: "2",
    label: "Mobile"
}
];

export const constLoyaltyGroup = [{
    id: 1,
    label: "Turnover"
}, {
    id: 11,
    label: "Turnover (Levels)"
}, {
    id: 2,
    label: "Win / Loss"
}, {
    id: 12,
    label: "Win / Loss (Levels)"
}, {
    id: 3,
    label: "Deposit"
}];

export const constDLSPromoGroup = [{
    id: 1,
    label: "Free Credit"
}, {
    id: 2,
    label: "Free Spin"
}];

export const constDLSProbability = [{
    id: 1,
    label: "Easy"
}, {
    id: 2,
    label: "Medium"
}, {
    id: 3,
    label: "Hard"
}, {
    id: 4,
    label: "Very Hard"
}, {
    id: 0,
    label: "Impossible"
}];

export const constDLSStatus = [{
    id: "2",
    label: "Success"
},
{
    id: "4",
    label: "Redeemed"
},
{
    id: "5",
    label: "Expired"
}
];

export const constLoyaltyStackable = [{
    id: 0,
    label: "No"
}, {
    id: 1,
    label: "Yes"
}];

export const constTypeOfPayout = [{
    id: 0,
    label: "Auto"
}, {
    id: 1,
    label: "Manual"
    }];

export const constRequestStatus = [{
    id: "1",
    label: "Pending"
}, {
    id: "2",
    label: "Approved"
}, {
    id: "3",
    label: "Rejected"
}];

export const constRejectReasonApp = [{
    id: "1",
    label: "App Icon not clear."
},
{
    id: "999",
    label: "Other"
}
];

export const consVisitorActType = [{
    id: 1,
    label: "Register"
},
{
    id: 2,
    label: "Login"
}
];

export const constSCBAppCardType = [{
    id: 'P1',
    label: 'Citizen ID'
}, {
    id: 'P8',
    label: 'Passport'

}];


export const constSCBAppBankNameList = [
    { id: '002', label: 'Bangkok Bank' },
    { id: '004', label: 'Kasikorn Bank' },
    { id: '005', label: 'Royal Bank of Scotland' },
    { id: '006', label: 'Krungthai Bank' },
    { id: '008', label: 'J.P. Morgan' },
    { id: '010', label: 'Bank of Tokyo-Mitsubishi UFJ' },
    { id: '011', label: 'TMB Bank' },
    { id: '014', label: 'Siam Commercial Bank' },
    { id: '017', label: 'Citibank' },
    { id: '018', label: 'Sumitomo Mitsui Banking Corporation' },
    { id: '020', label: 'Standard Chartered (Thai)' },
    { id: '022', label: 'CIMB Thai Bank' },
    { id: '024', label: 'United Overseas Bank (Thai)' },
    { id: '025', label: 'Bank of Ayudhya (Krungsri)' },
    { id: '026', label: 'Mega International Commercial Bank' },
    { id: '027', label: 'Bank of America' },
    { id: '028', label: 'Credit Agricole' },
    { id: '030', label: 'Government Savings Bank' },
    { id: '031', label: 'Hongkong and Shanghai Banking Corporation' },
    { id: '032', label: 'Deutsche Bank' },
    { id: '033', label: 'Government Housing Bank' },
    { id: '034', label: 'Bank for Agriculture and Agricultural Cooperatives' },
    { id: '039', label: 'Mizuho Bank' },
    { id: '045', label: 'BNP Paribas' },
    { id: '065', label: 'Thanachart Bank' },
    { id: '066', label: 'Islamic Bank of Thailand' },
    { id: '067', label: 'Tisco Bank' },
    { id: '069', label: 'Kiatnakin Bank' },
    { id: '070', label: 'Industrial and Commercial Bank of China (Thai)' },
    { id: '071', label: 'Thai Credit Retail Bank' },
    { id: '073', label: 'Land and Houses Bank' },
    { id: '076', label: 'TMBThanachart Bank' }
];

export const constAutoDepositBankApp = {
    "TSCB":
        [{
            id: 11,
            label: "Auto-Depo (APP)"
        },
        {
            id: 12,
            label: "Auto-Depo+ (APP)"
        }]
};

export const constAutoDepositType = [
    {
        id: 1,
        label: "Auto-Depo"
    },
    {
        id: 2,
        label: "Auto-Depo+"
    },
    {
        id: 3,
        label: "Auto-Depo & Auto-Depo+"
    },
    {
        id: 4,
        label: "ADB Auto-Depo"
    }
];
export const constAFB1188SkinW = [
    {
        id: "W0",
        label: "W0"
    },
    {
        id: "W0V2",
        label: "W0V2"
    },
    {
        id: "W0Blue",
        label: "W0Blue"
    },
    {
        id: "W0SBO",
        label: "W0SBO"
    },
    {
        id: "W0GGSport",
        label: "W0GGSport"
    },
    // default value
    //{
    //    id: "W0GG",
    //    label: "W0GG"
    //},
    {
        id: "W0LIGA",
        label: "W0LIGA"
    },
    {
        id: "W0LIGA|T1",
        label: "W0LIGA - IO"
    }
];
export const constAFB1188SkinM = [
    {
        id: "H50",
        label: "H50"
    },
    // default value
    //{
    //    id: "H50GG",
    //    label: "H50GG"
    //},
    {
        id: "H50GGSport",
        label: "H50GGSport"
    },
    {
        id: "H50LIGA",
        label: "H50LIGA"
    },
    {
        id: "H50LIGAV2",
        label: "H50LIGA - V2"
    },
    {
        id: "H50LIGAV2|lightgreen",
        label: "H50LIGAV2LG"
    },
    {
        id: "H50LIGAV2|lightred",
        label: "H50LIGAV2LR"
    },
    {
        id: "W0",
        label: "W0"
    },
    {
        id: "W0V2",
        label: "W0V2"
    },
    {
        id: "W0Blue",
        label: "W0Blue"
    },
    {
        id: "W0SBO",
        label: "W0SBO"
    },
    {
        id: "W0GG",
        label: "W0GG"
    },
    {
        id: "W0GGSport",
        label: "W0GGSport"
    },
    {
        id: "W0LIGA",
        label: "W0LIGA"
    },
    {
        id: "W0LIGA|T1",
        label: "W0LIGA - IO"
    }
];
export const constAFB1188OddsStyle = [
    {
        id: "HK",
        label: "HK"
    },
    {
        id: "MY",
        label: "MY"
    },
    {
        id: "EU",
        label: "EU"
    },
    {
        id: "ID",
        label: "ID"
    }
];
export const constAFB1188OddsMode = [
    {
        id: "Single",
        label: "Single"
    },
    {
        id: "Double",
        label: "Double"
    }
];
export const constAFB1188SportbookLaunchAPI = [
    {
        id: "www.play365.app",
        label: "www.play365.app"
    },
    {
        id: "api.jps128.com",
        label: "api.jps128.com"
    }
];
export const constBlackListFreezeListMode = [
    {
        id: "1",
        label: "Black List"
    },
    {
        id: "2",
        label: "Freeze List"
    }
];
export const constTranType = [
    {
        id: 1,
        label: "Credit (+)"
    },
    {
        id: 2,
        label: "Debit (-)"
    }
];
export const constSubAgentType = [
    {
        id: 1,
        label: 'SC1'
    },
    {
        id: 2,
        label: 'SC2'
    }
];
export const constSubAgentSchemeType = [
    {
        id: 1,
        label: 'TYP1'
    },
    {
        id: 2,
        label: 'TYP2'
    },
    {
        id: 3,
        label: 'TYP3'
    }
];

export const constHouseBrand = ['4', '81', '84', '57', '7', '53'];

export const loadingFullScreen = false;

export const constImageCURL = ['afb88go/afb88go/', 'liga365v2/black-limegreen/', 'liga365v2/klik855/', 'liga365v2/black-red/', 'liga365v2/black-safety-orange/', 'crazybet777/crazybet777/', 'yabo/'];

//export const constGPImageCURL = ['Custom/8MFN/', 'Custom/TSB77/', 'liga365v2/black-grey/', 'lobby03/', 'Custom/A168/', 'lobby01/', 'lobby01_light/', 'lobby02/', 'Custom/A168M/'];
export const constGPImageCURL = ['lobby01_light/', 'lobby01_black/', 'lobby02/', 'lobby03/', 'lobby04/', 'lobby05/', 'lobby06/'];

//GameProviderAccess
export const constSpecialProviders = [];

//ADB Automation (deposit||withdrawal)
// autoDepositCode (auto withdrawal)
export const constADBBankList = ["CBNI", "TBCEL", "CBMRI", "CBRI", "COCBC", "CBCA"]
// autoDepositCode (auto deposit)
export const constADBDepoBankList = ["TBCEL"]
// key is bank_code, value are bank_name
export const constADBBankSupportChannels = {
    "BNI": ['OVO', 'DANA', 'GOPAY', 'LINKAJA', 'BNI'],
    "BCEL": ['BCEL BANK'],
    "BMRI": ['MANDIRI', 'OVO', 'DANA', 'GOPAY'],
    "BRI": ['BRI', 'OVO', 'GOPAY'],
    "IOCB": ['OCBC'],
    "BCA": ['BCA', 'OVO', 'DANA', 'GOPAY']
}
// check account balance limit
export const constADBBankAccountBalanceLimit = 100;



// WEBPACK FOOTER //
// ./src/modules/Constant.js